import { callAPI } from "../../../../services/api.service";

export const searchCoupons = async (searchTerm: string) => {
    try {
        const data = await callAPI(`admin/coupon/search?searchTerm=${searchTerm}`);
        return data?.message || [];
    } catch (error) {
        throw error;
    }
};

export const getCoupons = async (currentPage: number) => {
    try {
        const data = await callAPI(`admin/coupon?pageNumber=${currentPage}`);
        return {
            coupons: data?.coupons || [],
            totalPages: data?.totalPages || 0,
        };
    } catch (error) {
        throw error;
    }
};

export const deleteCoupon = async (couponId: string) => {
    try {
        const response = await callAPI('admin/coupon/delete', { couponId });
        return response;
    } catch (error) {
        throw error;
    }
};
